import { UserPreferencesSchema } from "@/schemas/user.schema"
import { syncStore$ } from "@/stores/sync.v2.store"
import type { IRegisterDocumentProps } from "@/sync/syncTypes"
import consola from "consola"

export const UserPreferencesDocumentHandler = (name: string): IRegisterDocumentProps => ({
  name,
  onFailure: (error: unknown) => {
    consola.error(`Document ${name} failed`, error)
  },
  onRemoved: () => {
    consola.debug(`Document removed: ${name}`)
  },
  onDocumentUpdated: (data: unknown, rawData: unknown) => {
    const parsedItem = UserPreferencesSchema.safeParse(data)
    if (!parsedItem.success) {
      consola.error(`We will ignore the update from ${name} because the data is invalid`, parsedItem.error)
      return
    }

    syncStore$.userPreferences.set(parsedItem.data)
    consola.debug(`Updated state from ${name}`)
  },
})
